export const DEBUG_UI_ACTION_EVENT = 'himum:debug-ui-ui-action' as const;

export type DebugUiUiAction =
  | { type: 'revealPanel'; panelId: string }
  | { type: 'revealSceneNode'; nodeId: string };

export function dispatchUiAction(action: DebugUiUiAction): void {
  window.dispatchEvent(new CustomEvent<DebugUiUiAction>(DEBUG_UI_ACTION_EVENT, { detail: action }));
}

export function revealPanel(panelId: string): void {
  dispatchUiAction({ type: 'revealPanel', panelId });
}

export function revealSceneNode(nodeId: string): void {
  dispatchUiAction({ type: 'revealSceneNode', nodeId });
}
